<div class="g-0">
    <!-- Secțiunea Date Cetățean -->
    <div class="row">
        <div class="col-md">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title>
                                    <i class="fa-solid fa-user"></i>
                                    <span>Date Cetățean</span>
                                </mat-card-title>
                                <button
                                    *ngIf="permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.update-subsemnat')"
                                    class="btn btn-small btn-warning edit-btn" (click)="openEditSubsemnat()">
                                    <i class="fa fa-pencil fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <ng-container *ngIf="selectedSubsemnatulStatus === 'info'">
                        <table class="table table-condensed table-wrapper-box mb-0">
                            <tbody>
                                <tr>
                                    <td width="40%" class="text-center">
                                        <strong><i class="fa-solid fa-id-card me-1"></i>Nume</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.prenume }} {{ cerere.cetatean?.nume }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-fingerprint me-1"></i>{{
                                            cerere.cetatean?.persoana_type === 1 ? "CNP" : "CUI" }}</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.cnp || 'N/A' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-phone me-1"></i>Telefon</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.telefon || 'N/A' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-envelope me-1"></i>Email</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.email || 'N/A' }}</td>
                                </tr>
                                <tr>
                                    <td class="text-center">
                                        <strong><i class="fa-solid fa-sticky-note me-1"></i>Observații</strong>
                                    </td>
                                    <td class="text-left">{{ cerere.cetatean?.observatii || cerere.description || 'n/a'
                                        }}</td>
                                    <!-- <td class="text-left p-0">
                                        <div class="p-2"
                                            style="background-color: #fffde7; border-radius: 4px; border-left: 4px solid #ffc107;">
                                            <i class="fa-solid fa-quote-left text-muted me-1"></i>
                                            {{ cerere.cetatean?.observatii || cerere.description || 'n/a' }}
                                            <i class="fa-solid fa-quote-right text-muted ms-1"></i>
                                        </div>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <!-- Secțiunea Detalii Programare -->
    <div class="row mt-2" *ngIf="cerere.programare">
        <div class="col-md">
            <div class="box-wrapper box-programare">
                <div class="box-content-header" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title style="color: white;">
                                    <i class="fa-solid fa-calendar-check"></i>
                                    <span>Detalii Programare</span>
                                </mat-card-title>
                                <div class="d-flex gap-1">
                                    <button
                                        *ngIf="permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.update-config-programare')"
                                        [disabled]="cerere.cancel_date" class="btn btn-sm btn-light"
                                        (click)="openEditProgramareConfig()" title="Editare tip problemă/program">
                                        <i class="fa fa-pencil fa-sm"></i>
                                    </button>
                                    <button
                                        *ngIf="permissionsService.hasPermission('auth-module.ghiseu.view-ghiseu.change-programare')"
                                        [disabled]="cerere.cancel_date" class="btn btn-sm btn-info"
                                        (click)="openRescheduleProgramare()" title="Reprogramare">
                                        <i class="fa-solid fa-calendar-alt"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <!-- Data și Ora - evidențiate -->
                    <div class="row mb-2">
                        <div class="col-6">
                            <div class="programare-highlight text-center p-2"
                                style="background-color: #e3f2fd; border-radius: 8px;">
                                <div class="text-muted small"><i class="fa-solid fa-calendar-day me-1"></i>Data
                                    programării</div>
                                <div class="fw-bold fs-5" style="color: #1565c0;">
                                    {{ cerere.programare?.date | date:'dd.MM.yyyy' }}
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="programare-highlight text-center p-2"
                                style="background-color: #fff3e0; border-radius: 8px;">
                                <div class="text-muted small"><i class="fa-solid fa-clock me-1"></i>Ora programării
                                </div>
                                <div class="fw-bold fs-5" style="color: #ef6c00;">
                                    {{ cerere.programare?.time_from }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <table class="table table-condensed table-wrapper-box mb-0">
                        <tbody>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong><i class="fa-solid fa-calendar-check me-1"></i>Programare</strong>
                                </td>
                                <td class="text-left">
                                    <span *ngIf="cerere.programare?.active === 1" class="badge"
                                        style="background-color: #39612C; color: white;">
                                        Activă
                                    </span>
                                    <span *ngIf="cerere.programare?.active !== 1" class="badge"
                                        style="background-color: #dd4b39; color: white;">
                                        Inactivă
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td width="40%" class="text-center">
                                    <strong><i class="fa-solid fa-building-columns me-1"></i>Modul</strong>
                                </td>
                                <td class="text-left">{{ cerere.programare?.denumire_modul || 'N/A' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-location-dot me-1"></i>Locație</strong>
                                </td>
                                <td class="text-left">{{ cerere.programare?.denumire_locatie || 'N/A' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-concierge-bell me-1"></i>Serviciu</strong>
                                </td>
                                <td class="text-left">{{ cerere.programare?.denumire_serviciu || 'N/A' }}</td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-list-check me-1"></i>Tip program</strong>
                                </td>
                                <td class="text-left">
                                    <span class="badge" style="background-color: #7c4dff; color: white;">
                                        {{ cerere.programare?.denumire_program_type || 'N/A' }}
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="cerere.denumire_problem_type">
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-circle-question me-1"></i>Tip problemă</strong>
                                </td>
                                <td class="text-left">
                                    <span class="badge" style="background-color: #00bcd4; color: white;">
                                        {{ cerere.denumire_problem_type }}
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="cerere.programare?.duration">
                                <td class="text-center">
                                    <strong><i class="fa-solid fa-hourglass-half me-1"></i>Durată</strong>
                                </td>
                                <td class="text-left">{{ cerere.programare?.duration }} minute</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>